import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "vue-phone-number-input like-input d-flex" }
const _hoisted_2 = { class: "field-country-flag" }
const _hoisted_3 = {
  key: 0,
  class: "dial-code"
}

import {countries, countriesIso, PhoneCodeCountry} from './assets/js/phoneCodeCountries';
import TheMask from './the-mask/component.vue';
import CountrySelector from './_subs/CountrySelector.vue'
import {ComponentInstance, computed, nextTick, ref, watch} from "vue";
import ConsoleWrapper from "~/ts/library/Console";
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import Random from "~/ts/library/Random";
import VuePhoneNumberInputExposeInterface
    from "~/chat/vue/widget/form/fields/VuePhoneNumberInput/VuePhoneNumberInputExposeInterface";
import CountrySelectorExposeInterface
    from "~/chat/vue/widget/form/fields/VuePhoneNumberInput/_subs/CountrySelectorExposeInterface";


interface IPayload {
    countryCode: string,
    phoneNumber: string
}

const __default__ = {
    name: "VuePhoneNumberInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    defaultCountryCode: {},
    noUseBrowserLocale: { type: Boolean },
    placeholder: {},
    hideArrow: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {

const browserLocale = () => {
    if (!window) return null;
    const browserLocale = (window.navigator as any).userLanguage || window.navigator.language;
    let locale = browserLocale ? browserLocale.substr(3, 4).toUpperCase() : null;
    if (locale === '') locale = browserLocale.substr(0, 2).toUpperCase();
    return locale
};

const isCountryAvailable = (locale: string) => {
    return countriesIso.indexOf(locale) > -1;
};

let props = __props;

let model = _useModel<string>(__props, "modelValue");


let randomName = computed(() => {
    return Random.uid(10);
});

let tokens = computed(() => {
    return {
        'R': {pattern: /[0-6,9]/},
        'Z': {pattern: /[1-9]/},
        '#': {pattern: /\d/}
    }
});

let results = ref<Partial<IPayload>>({});

let countrySelectorRef = ref<CountrySelectorExposeInterface>();

function onArrowClick() {
    countrySelectorRef.value?.onFocus();
}

function detectCountryCodeByValue(): PhoneCodeCountry | null {
    if (model.value && model.value.length) {
        let value = clearValue(model.value);
        let newCountry = null;
        for (let country of countries) {
            if (value.indexOf(country.dialCode) == 0) {
                if (!newCountry || newCountry.dialCode.length < country.dialCode.length) {
                    newCountry = country;
                }
            }
        }
        if (newCountry && newCountry.iso2 != results.value.countryCode) {
            emitValues({
                phoneNumber: value,
                countryCode: newCountry.iso2
            });
        }
        return newCountry;
    }
    return null;
}

function clearValue(value: string) {
    return value.replace(/\D/g, "");
}

let mask = computed(() => {
    let country = countries.find(country => country.iso2 == countryCode.value);
    return country ? country.mask : "#####################";
});

let codesCountries = computed(() => {
    return countries
});

let locale = computed(() => {
    let detectByValue = detectCountryCodeByValue();
    if (detectByValue) {
        return detectByValue.iso2;
    }
    const locale = props.defaultCountryCode || (!props.noUseBrowserLocale ? browserLocale() : null);
    const countryAvailable = isCountryAvailable(locale);

    if (countryAvailable && locale) {
        countryCode.value = locale
    } else if (!countryAvailable && props.defaultCountryCode) {
        // If default country code is not available
        ConsoleWrapper.warn(`The locale ${locale} is not available`)
    }
    return countryAvailable ? locale : null
});

let country = computed(() => {
    return countries.find(country => country.iso2 == countryCode.value);
});

let countryCode = computed({
    get: () => {
        return results.value.countryCode || locale.value
    },
    set: (newCountry: any) => {
        emitValues({countryCode: newCountry, phoneNumber: phoneNumber.value});

    }
});


let phoneNumber = computed({
    get: () => {
        return model.value
    },
    set: (newPhone: any) => {
        emitValues({countryCode: countryCode.value, phoneNumber: newPhone})
    }
});

let phoneNumberInputRef = ref<ComponentInstance<any>>();


function onCountryCodeInput(value: string) {
    if (countryCode.value != value) {
        nextTick(() => {
            (phoneNumberInputRef.value.$el as HTMLInputElement).focus();
        });
    }
    emitValues({
        countryCode: value,
        phoneNumber: ""
    });

}

function emitValues(payload: IPayload) {
    let phoneNumber = payload.phoneNumber ? payload.phoneNumber : "";

    model.value = phoneNumber;
    results.value = payload;
}

function onFocus() {
    if (!model.value.length) {
        model.value = country.value.dialCode;
    }
}

function onBlur() {
    if (clearValue(model.value) == country.value.dialCode || !model.value.length) {
        model.value = "";
    }
}

function focus() {
    (phoneNumberInputRef.value?.$el as HTMLInputElement).focus();
}

function onCaretPositionChange(event: KeyboardEvent) {
    let input: HTMLInputElement = event.target as any;
    let firstMaskNumberIndex = Math.min(...[mask.value.indexOf("#"), mask.value.indexOf("R")].filter(value => value > -1));
    if (firstMaskNumberIndex > input.selectionStart) {
        let newSelectionStart = firstMaskNumberIndex;
        if (newSelectionStart > input.value.length) {
            newSelectionStart = input.value.length;
        }
        input.selectionStart = newSelectionStart;
    }
}

watch(computed(() => props.defaultCountryCode), () => {
    if (props.defaultCountryCode && (!model.value || !model.value.length)) {
        countryCode.value = props.defaultCountryCode;
    }
});

__expose<VuePhoneNumberInputExposeInterface>({
    focus
})


return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: onArrowClick,
        class: _normalizeClass(`iti-flag-small iti-flag cursor-pointer ${_unref(countryCode).toLowerCase()}`)
      }, null, 2),
      _withDirectives(_createVNode(SvgIcon, {
        class: "chevron placeholder-color",
        "icon-name": "chevron-down",
        "icon-style": "light"
      }, null, 512), [
        [_directive_on_native, onArrowClick, "click"]
      ]),
      (!_unref(model))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " +" + _toDisplayString(_unref(country).dialCode), 1))
        : _createCommentVNode("", true),
      _createVNode(CountrySelector, {
        ref_key: "countrySelectorRef",
        ref: countrySelectorRef,
        "model-value": _unref(countryCode),
        "onUpdate:modelValue": onCountryCodeInput,
        items: _unref(codesCountries),
        class: "input-country-selector"
      }, null, 8, ["model-value", "items"])
    ]),
    _withDirectives(_createVNode(TheMask, {
      type: "tel",
      ref_key: "phoneNumberInputRef",
      ref: phoneNumberInputRef,
      modelValue: _unref(phoneNumber),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(phoneNumber) ? (phoneNumber).value = $event : phoneNumber = $event)),
      mask: _unref(mask),
      masked: "",
      autocomplete: "new-password",
      name: _unref(randomName),
      id: "input-phone-number",
      class: "with-icon with-icon-right filler",
      placeholder: _ctx.placeholder,
      tokens: _unref(tokens)
    }, null, 8, ["modelValue", "mask", "name", "placeholder", "tokens"]), [
      [
        _directive_on_native,
        onFocus,
        "focus",
        { stop: true }
      ],
      [
        _directive_on_native,
        onBlur,
        "blur",
        { stop: true }
      ],
      [
        _directive_on_native,
        onCaretPositionChange,
        "keydown",
        { stop: true }
      ],
      [
        _directive_on_native,
        onCaretPositionChange,
        "click",
        { stop: true }
      ],
      [
        _directive_on_native,
        onCaretPositionChange,
        "touchend",
        { stop: true }
      ],
      [
        _directive_on_native,
        void 0,
        "mousedown",
        { stop: true }
      ],
      [
        _directive_on_native,
        void 0,
        "mouseup",
        { stop: true }
      ],
      [
        _directive_on_native,
        void 0,
        "input",
        { stop: true }
      ]
    ])
  ]))
}
}

})